/**
 * History Page
 * ============
 * Extracted from frontend/history/index.blade.php
 *
 * Handles:
 * - toggleFavorite() reuses the unified version from layout-globals.js
 * - downloadFile() creates a hidden download link
 *
 * Blade→JS bridge: <script type="application/json" id="history-config">
 */

function initHistoryPage() {
    const configEl = document.getElementById('history-config');
    if (!configEl) return; // Not on history page

    let config;
    try {
        config = JSON.parse(configEl.textContent);
    } catch (e) {
        console.error('❌ Error parsing history-config:', e);
        return;
    }

    const { downloadUrlBase } = config;

    /**
     * Download a file by ID (history page version - creates a hidden link)
     * Overrides the global downloadFile for this page's specific behavior
     */
    window.downloadFile = function(archivoId) {
        const link = document.createElement('a');
        link.href = downloadUrlBase + '/' + archivoId;
        link.download = '';
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    // toggleFavorite() is already available globally from layout-globals.js
    // The history page uses onclick="toggleFavorite(id)" which calls the unified version

    console.log('📜 History page inicializada');
}

document.addEventListener('DOMContentLoaded', initHistoryPage);
